import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Fire-and-forget outbound click tracking (partner/engine links).
export function trackClick(target) {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ target }),
    }).catch(() => {});
  } catch (e) {
    // never block the UI on analytics
  }
}
